import { isDatetimeType } from "./types.js";
import { formatMilliseconds, formatMicroseconds } from "hb/lib/number_helpers";

export const dimensionTypes = {
  datetime: "time",
  integer: "number",
  float: "number",
  string: "ordinal",
};

export function dimensionType(type) {
  if (isDatetimeType(type)) {
    return "datetime";
  }

  return dimensionTypes[type];
}

export const axisTypes = {
  datetime: "time",
  integer: "value",
  float: "value",
  string: "category",
};

export function axisType(type) {
  if (isDatetimeType(type)) {
    return "time";
  }

  return axisTypes[type];
}

export function valueFormatter(unit) {
  switch (unit) {
    case "percent":
      return (d) => d + "%";
    case "microseconds":
      return formatMicroseconds;
    case "milliseconds":
      return formatMilliseconds;
    default:
      return null;
  }
}
